import { useEffect, useRef } from "react"

export default function useClickOutside<T extends HTMLElement>(
  handler: () => void
) {
  const ref = useRef<T | null>(null)

  useEffect(() => {
    // Handler for outside click
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        handler()
      }
    }

    // Add event listener to document
    document.addEventListener("mousedown", handleClickOutside)

    // Clean up event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [handler])
  return ref
}
